<template>
	<Modal
		:is-open="announcementModalOpened"
		@close="closeAnnouncementModal"
		contentClass="modal-content--announcement"
	>
		<template v-slot:title><span data-qa="announcement-title">{{ announcementTitle }}</span></template>
		<br>
		<div class="announcement-modal">
			<p v-for="(item, index) in announcementBody" :key="index" v-html="renderParagraph(item)" data-qa="announcement-body-text"></p>
			<div class="announcement-modal__actions">
				<AppButton variant="primary" :showIcon="false" :disabled="isAcknowledging" @click="acknowledge" data-qa="announcement-confirm-button">
					{{ announcementCtaLabel }}
				</AppButton>
			</div>
		</div>
	</Modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Modal from '@/components/Modal.vue';
import AppButton from '@/components/ui/AppButton.vue';

//const STORAGE_PREFIX = 'lgfc-announcement-confirmed';
const DISCOURSE_REGULATION_TYPE_ID = 2;

export default {
	name: 'AnnouncementModal',
	components: {
		Modal,
		AppButton
	},
	data() {
		return {
			isAcknowledging: false
		};
	},
	computed: {
		...mapGetters(['announcementModalOpened', 'announcementModalPayload']),
		login() {
			return {
				logged: !!this.$store.state.auth.user
			};
		},
		hasAcceptedDiscourseRegulation() {
			const memberOptIn = this.$store.state.auth.user?.memberOptIn;
			return !!memberOptIn && Number(memberOptIn?.optInTypeId) === DISCOURSE_REGULATION_TYPE_ID;
		},
		announcementTitle() {
			return this.announcementModalPayload?.title || '';
		},
		announcementBody() {
			return this.announcementModalPayload?.body || [];
		},
		announcementCtaLabel() {
			return this.announcementModalPayload?.ctaLabel || 'Confirmar';
		}
	},
	mounted() {
		this.maybeOpen();
	},
	watch: {
		'login.logged'(isLogged) {
			if (isLogged) this.maybeOpen();
		},
		'$route.path'() {
			if (this.isTermsRoute()) {
				this.closeAnnouncementModal();
				return;
			}
			this.maybeOpen();
		},
		announcementModalPayload: {
			handler() {
				this.maybeOpen();
			},
			deep: true
		}
	},
	methods: {
		...mapActions(['openAnnouncementModal', 'closeAnnouncementModal']),
		resolveLink(link) {
			if (link?.to) return link.to;
			if (link?.toKey) return this.$t(link.toKey);
			return link?.href || '#';
		},
		isTermsRoute() {
			const termsPath = this.$t('footer.termsOfUse.url');
			const currentPath = this.$route?.path || '';
			if (!termsPath) return false;
			if (currentPath === termsPath) return true;
			return currentPath.endsWith(termsPath);
		},
		renderParagraph(item) {
			if (!item) return '';
			if (typeof item === 'string') return item;
			if (item.html) return item.html;
			let html = item.text || '';
			if (item.link) {
				const href = this.resolveLink(item.link);
				const resolvedHref = this.$router?.resolve(href)?.href || href;
				const label = item.link.label || resolvedHref;
				html += `<a class="announcement-modal__link" href="${resolvedHref}">${label}</a>`;
			}
			if (item.suffix) html += item.suffix;
			return html;
		},
		maybeOpen() {
			const payload = this.announcementModalPayload || {};
			if (!this.login.logged || !payload.active || !payload.id) return;
			if (this.isTermsRoute()) return;
			if (this.hasAcceptedDiscourseRegulation) return;
			if (!this.announcementModalOpened) {
				this.openAnnouncementModal();
			}
		},
		acknowledge() {
			if (this.isAcknowledging) return;
			this.isAcknowledging = true;
			this.$store.dispatch('members/acceptRegulation', { body: { optInTypeId: DISCOURSE_REGULATION_TYPE_ID } })
				.then((resp) => {
					const memberOptIn = resp?.data?.optInMembers?.optIn;
					if (memberOptIn) this.$store.commit('auth/setMemberOptIn', memberOptIn);
					this.closeAnnouncementModal();
				})
				.finally(() => {
					this.isAcknowledging = false;
				})
		}
	}
};
</script>
